import {Component, Inject, OnInit, Renderer2,ElementRef, PLATFORM_ID} from '@angular/core';
import {ActivatedRoute, Router, Event} from '@angular/router';
import {Subscription} from 'rxjs';
import {ApiServices} from '../../../shared/services/api.service';
import {Brand, Finish, ProductReview, ProductVariant, SingleProduct} from '../../../shared/interfaces/wheels';
import {FormGroup} from '@angular/forms';
import {FormService} from '../../../shared/services/form.service';
import {HelperService} from '../../../shared/services/helper.service';
import {DataService} from '../../../shared/services/data.service';
import {RandomFinish} from '../../../shared/modals/RandomFinish';
import {ToastrService} from 'ngx-toastr';
import {ImagePathPipe} from '../../../shared/pipes/image-path.pipe';
import {Product, Inventory} from '../../../shared/interfaces/ProductDetailResponse';
import {isPlatformBrowser} from '@angular/common';
import {MyProfile} from '../../../shared/interfaces/MyAccount.interface';

import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import {MetaService} from '../../../shared/services/meta.service';

import * as $ from 'jquery';

interface clickedVendor{
  vendor: string,
  is_approved: number
}

@Component({
  selector: 'app-wheels-detail',
  templateUrl: './wheels-detail.component.html',
  styleUrls: ['./wheels-detail.component.scss']
})
export class WheelsDetailComponent implements OnInit {

  id: number;
  variantID: number;
  wheelDetailSubscription: Subscription;
  wheelData: Product;
  years: any[] = [];
  makes = [];
  models = [];
  vehicleSubscription: Subscription;
  cartSubscription: Subscription;
  searchVehicleSub: Subscription;
  vehicleWheelsData: [ProductVariant];
  form: FormGroup;
  checkfitment = false;
  vehicle: any;
  totalPrice: number;
  specification: ProductVariant;
  fitmentData: any;
  searchSelectionSub: Subscription;
  vehicleFormDataSub: Subscription;
  finishes: Finish[];
  countryCode = 'AE';
  deliveryDate: any;
  brand: Brand;
  private cartItems: any[] = [];
  private cartProcessing = false;
  fitmentSubscription: Subscription;
  albums = [];
  showFlag  = false;
  selectedImageIndex = -1;
  reviewForm: FormGroup;
  productReviews: ProductReview[];
  inventory: Inventory[];
  loginSubscription: Subscription;
  isLoggedIn = false;
  isLoading = false;
  searchSelectionsSubscription: Subscription;
  searchWheelFormData: Subscription;
  searchSelections = false;
  wheelApiData: any;
  loadSizes = false;
  closeResult: string;
  cartResp:any = null;
  addons = [];
  cartaddons:any;
  cartId:any;
  productId:any;
  finishName:any = null;
  successMessage: string = '';
  productCartTotalQty:number = 0;
  prodQty:number[]=[];
  warehouse_quantity:any = {};

  showpostpaypopup = 'no';

  wheelFitsData: any = [];
  is_hide_cost:any = null;
  profileData: MyProfile; // Added missing property for plan validation
  moreSizes:any = [];
  wheelSizeTypes:any = [];
  vendor_is_approved:boolean = true;

  offsetDropdownValues = [];
  isProductCustomization = false;
  custom_finish = '';
  custom_finish_price;
  bolt_pattern = 'recommended';
  offset = 'recommended';
  pc_cost_per_wheel;
  vehicle_year_make_model = '';
  p_customization_submitted = false;
  addToCartPopup: NgbModalRef;
  eta: string;

  inventoryData:any = []
  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiServices,
    private helperService: HelperService,
    private dataService: DataService,
    private router: Router,
    private toastr: ToastrService,
    public imagePath: ImagePathPipe,
    private formService: FormService,
    private modalService: NgbModal,
    private metaService: MetaService,
    private _renderer2: Renderer2,
    private elRef: ElementRef,
    @Inject(PLATFORM_ID) private platformID: any
  ) {
    // Get profile data first, then determine cost hiding securely
    this.dataService.myAccountData.asObservable().subscribe(
      myAccountData => {
        if (myAccountData) {
          this.profileData = myAccountData.my_profile;
          // Security: Use secure method to determine cost hiding
          this.is_hide_cost = this.helperService.shouldHideCost(this.profileData) ? "1" : null;
        }
      }
    );
    
    if (isPlatformBrowser(this.platformID)) {
      activatedRoute.params.subscribe(param => {
        this.id = param.id;
        this.variantID = param.variant_id;
        window.scroll(0, 0);
        this.getWheelDetail();
      });
    }
    // this.subscribes();
    this.reviewForm = this.formService.productReviewForm();

    this.router.events.subscribe((event: Event) => {
      this.showpostpaypopup = 'no';
    });
  }

  subscribes(): void {
    // this.dataService.searchSelections.asObservable().subscribe(data => {
    //   if (data && data.year && data.make && data.model) {
    //     this.vehicle = data.year + ' ' + data.make + ' ' + data.model;
    //   }
    // });
    // this.fitmentSubscription = this.dataService.checkFitment.asObservable().subscribe(fitment => this.checkfitment = fitment);
    // this.searchSelectionsSubscription = this.dataService.searchSelections.asObservable().subscribe(searchSelections => this.searchSelections = searchSelections);
    // this.loginSubscription = this.dataService.isLoggedIn.asObservable().subscribe(loggedIn => this.isLoggedIn = loggedIn);
    // this.searchWheelFormData = this.dataService.vehicleFormData.asObservable().subscribe(wheelApiData => this.wheelApiData = wheelApiData);

  }

  ngOnInit(): void {
    this.metaService.updateCanonicalURL();
  }

  getDeliveryDate = () => {
    this.apiService.getUserLocation().subscribe(
      response => {
        let countryCode = 'AE';
        if (response.countryCode) {
          countryCode = response.countryCode;
        }
        this.deliveryDate = this.helperService.deliveryDate(countryCode, this.brand);
      }
    );
  }

  getWheelDetail = () => {
    this.finishName = '';
    this.moreSizes = [];
    this.wheelSizeTypes = [];
    const vendorID = this.activatedRoute.snapshot.queryParams['vendor'];

    if (vendorID) {
      let clickedVendor = localStorage.getItem("clickedVendor");
      if (clickedVendor) {
        const stringifiedVendor = JSON.parse(clickedVendor) as clickedVendor;
        if(vendorID == stringifiedVendor.vendor) {
          this.vendor_is_approved = stringifiedVendor.is_approved == 1 ? true : false;
        }
      }
    }

    this.wheelDetailSubscription = this.apiService.getWheelDetail(this.id, this.variantID, this.vendor_is_approved).subscribe(
      response => {
        this.addons = response.data.addons;
        
        this.wheelData = response.data.product;
        this.eta = response.data?.inventory[0]?.eta;
        this.wheelData.images = JSON.parse(this.wheelData.images);
        this.productReviews = response.data.product_reviews;
        this.inventory = response.data.inventory;
        this.finishes = response.data.finishes;
        this.brand = response.data.product.brand;
        this.prodQty[response.data.product.variant.id] = 1;

        this.wheelSizeTypes = response.data.more_sizes;

        this.generateOffsetDropdownValues(this.wheelData.variant.offset);

        this.getFitsList();
        // console.log(this.finishes);

        this.setAlbumImages();
        // this.searchVehicle();

        this.getDeliveryDate();
        if (this.finishes) {
          this.parseImages(this.finishes);
          this.getCurrentFinishName(this.finishes, this.wheelData.finish_id);

        }
        this.reviewForm.patchValue({product_id: this.wheelData.id});
        // this.helperService.setPageTitle(this.wheelData.brand.name + ' - ' + this.wheelData.model.name);
        this.helperService.setPageTitle(this.wheelData.seo_title);
        if (!Array.isArray(this.wheelData.images)) {
          this.wheelData.images = JSON.parse(this.wheelData.images);
        }
        this.resolveMetaTags();
        // this.totalPrice = this.wheelData.uae_retail_price;

        this.addTagManagerScript();

        if( this.wheelSizeTypes.length > 0 ){
          this.getVariantsData(this.wheelData.id, this.wheelData.variant.id, this.wheelSizeTypes[0]);
        }


      }, error => {
      }
    );

  }

  setWarehouse(warehouse_id) {
    this.warehouse_quantity['warehouse_id'] = warehouse_id;
    this.warehouse_quantity['quantity'] = 1;
    this.warehouse_quantity['product'] = this.wheelData.id;
  }

  getFitsList = () => {
    this.wheelFitsData = [];

    let bolt_pattern = this.wheelData.variant.bolt_pattern;
    bolt_pattern = bolt_pattern.trim();
    let rim_diameter = this.wheelData.variant.rim_diameter;
    const queryString = 'bolt_pattern='+bolt_pattern+'&rim_diameter='+rim_diameter+'&rim_width_min=7&rim_width_max=9&mode=both';
    this.apiService.getWheelFits(queryString).subscribe(
      (response: any) => {
        console.log('[getFitsList] Raw API response:', response);
        const fitmentData = response?.data?.data;
        const meta = response?.data?.meta;
        if (meta?.count !== undefined) {
          if (meta.count > 0 && Array.isArray(fitmentData)) {
            this.wheelFitsData = fitmentData;
            console.log('[getFitsList] wheelFitsData assigned:', this.wheelFitsData);
          } else {
            this.wheelFitsData = [];
            console.log('[getFitsList] No fitment found, meta.count:', meta.count);
          }
        } else {
          this.wheelFitsData = [];
          console.warn('[getFitsList] Unexpected API response structure:', response);
        }
      }, error => {
        this.wheelFitsData = [];
        console.error('[getFitsList] Error fetching wheel fits:', error);
      }
    );
  }

  getVariantsData(pId, vId, diameter){
    // console.log(pId, vId, diameter);
    this.apiService.getWheelDetailMoreSize(pId, vId, diameter).subscribe(
      response => {
        // console.log(response);
        if(response.data.sizes.length > 0){
          this.moreSizes = response.data.sizes;
        }

      }, error => {
        this.helperService.showErrors(error);
      }
    );

  }

  resolveMetaTags(): void {
    this.helperService.setCustomMeta({
      title: this.wheelData.seo_title,
      description: this.wheelData.meta_description,
      keywords: this.wheelData.meta_keywords
    });
  }

  setAlbumImages(): void {
    if (!this.wheelData.images) {
      return;
    }
   // const images = JSON.parse(this.wheelData.images);
    this.wheelData.images.forEach(img => {
      const image = this.imagePath.transform(img);
      const title = this.wheelData.name;
      const thumbImage = image;
      const album = {
        image,
        thumbImage,
        title,
        alt: title
      };

      this.albums.push(album);
    });

  }

  parseImages = (data) => {
    data.forEach(item => {
      item.images = JSON.parse(item.images);
    });
  }

  getCurrentFinishName = (data, id) => {
    data.forEach(item => {
        if(item.finish.id == id){
          this.finishName = item.finish.finish;
        }
    });
  }

  // tslint:disable-next-line:use-lifecycle-interface typedef
  ngOnDestroy() {
    if(this.wheelDetailSubscription) {
      this.wheelDetailSubscription.unsubscribe();
    }
    if (this.searchVehicleSub) {
      this.searchVehicleSub.unsubscribe();
    }

    if (this.vehicleFormDataSub) {
      this.vehicleFormDataSub.unsubscribe();
    }

    if (this.searchSelectionSub) {
      this.searchSelectionSub.unsubscribe();
    }

    if (this.fitmentSubscription) {
      this.fitmentSubscription.unsubscribe();
    }

    if (this.searchWheelFormData) {
      this.searchWheelFormData.unsubscribe();
    }

    this.dataService.vehicleFormData.next(null);
    this.dataService.checkFitment.next(false);
  }


  onCheckFitment = (fitmentData) => {

    if (fitmentData) {
      this.vehicle = fitmentData.vehicle;
      this.fitmentData = fitmentData;
      this.searchVehicle();
     // this.checkfitment = true;
    } else {
     // this.checkfitment = false;
    }
  }


  searchVehicle = () => {
    const formParams = {
      bolt_pattern: this.wheelApiData ? this.wheelApiData.bolt_pattern : null,
      model_id: this.wheelData.model_id,
      brand_id: this.wheelData.brand_id,
      product_id: this.wheelData.id
    };
    this.loadSizes = true;
    this.searchVehicleSub = this.apiService.searchSize(formParams).subscribe(
        response => {
          if (response.data && response.data.length) {
            this.vehicleWheelsData = response.data;
            this.checkfitment = true;
            this.onChangeSize();
            this.loadSizes = false;
          } else {
            this.checkfitment = false;
            this.loadSizes = false;
          }
        }, console => {
          this.checkfitment = false;
          this.loadSizes = false;
      }
    );
  }

  onChangeSize = (index = 0) => {
    this.specification = this.vehicleWheelsData[index];
  }

  onChangeQuantity = (totalPrice) => {
    this.totalPrice = totalPrice;
  }

  onAddToCart(): void {

    let inv = this.inventory;
    let prodQtys = this.prodQty;
    let error = true;
    let items:any = [];
    const variantId = this.wheelData.variant.id;

    let item:any = {};
    let warehouse_qunatity:any = {};

    let totalQty:number=0;

    item.product_id = this.wheelData.id;
    item.product_variant_id = this.wheelData.variant.id;
    item.type = "";
    if (this.wheelData.id === this.warehouse_quantity['product']) {
      delete this.warehouse_quantity["product"]
      item.warehouse_qunatity = [this.warehouse_quantity]
    }
    // item.warehouse_qunatity = [];

    var _self = this;

    // inv.forEach(function(v,i){

    //   if(prodQtys[v.warehouse.id] >  (v.quantity+v.eta_qty)){
    //     _self.toastr.error("Invalid quantity. "+v.warehouse.warehouse_name+" have only "+v.quantity+" quantity left.", 'Error');
      
    //   } 
    //   else if(prodQtys[v.warehouse.id] <= 0 ){
    //     _self.toastr.error("("+v.warehouse.warehouse_name+") Invalid quantity.", 'Error');
    //   }
    //   else if(prodQtys[v.warehouse.id] > 0) {
    //     error = false;
    //     totalQty += prodQtys[v.warehouse.id];
    //     warehouse_qunatity = {};
    //     warehouse_qunatity.warehouse_id = v.warehouse.id;
    //     warehouse_qunatity.quantity = prodQtys[v.warehouse.id];
    //     item.warehouse_qunatity.push(warehouse_qunatity);

    //   }
    // });
    // item.quantity = totalQty;
    if(this.wheelData.eta_quantity > 0 && (this.wheelData.eta_quantity > prodQtys[variantId])) {
      error = false;
    }
    else if(prodQtys[variantId] > this.getTotalQtyProduct(inv)){
      _self.toastr.error("Invalid quantity. only "+this.getTotalQtyProduct(inv)+" quantity left.", 'Error');
    }
    else if(prodQtys[variantId] <= 0 ){
      _self.toastr.error("Invalid quantity.", 'Error');
    }
    else if(prodQtys[variantId] > 0 ) {
      error = false;
    } 


    item.quantity = this.prodQty[variantId];


    items.push(item);

    /*if(totalQty < 4){
      error = true;
      this.toastr.error("Minimum purchase quantity should be 4", 'Error');
    }*/

    if(!error){

      this.productCartTotalQty = item.quantity;
      this.cartItems = items;
      this.addToCart();

    } else {
      this.productCartTotalQty = 0;
    }
  }

  addEditQty(warehouseCode, warehouseId, warehouseTotalQty, eta_qty=0, qty):void{
    let inv = this.inventory;
    let prodQtys = this.prodQty;
    let totalQty = 0;
    let allQtySum = eta_qty+warehouseTotalQty;

    if(qty > allQtySum){
      this.toastr.error("Invalid quantity. "+warehouseCode+" have only "+allQtySum+" quantity left.", 'Error');
    } else if(prodQtys[warehouseId] >= 0) {
      inv.forEach(function(v,i){
        totalQty += prodQtys[v.warehouse.id];
      });
    } else if(prodQtys[warehouseId] < 0){
      this.toastr.error("("+warehouseCode+") Invalid quantity.", 'Error');
    }
    this.productCartTotalQty = totalQty;
  }

  addToCart(): void {
    // tslint:disable-next-line:variable-name
    this.addons = [];
    const session_id = localStorage.getItem('session_id');
    const data = {
      session_id,
      items: this.cartItems,
    };
    this.cartProcessing = true;
    this.cartSubscription = this.apiService.addToCart(data).subscribe(
      response => {
        this.cartProcessing = false;
        if (response.status) {

          let totalItem =  this.cartItems.length;

          // $( "#gtagId" ).remove();
          /*let script = this._renderer2.createElement('script');
          script.type = 'text/javascript';
          script.id = 'gtagId';
          script.text = `
          dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
              'currencyCode': '$',
              'add': {
                'products': [`;

          this.cartItems.forEach(function (value, key) {
              script.text += `{
                'id': '`+value.product_id+`',
                'variant': '`+value.product_variant_id+`',
                'quantity': '`+value.quantity+`',
                'type': '`+value.type+`',
                'category': 'Alloy Wheel'
              }`;
            if((key+1) !== totalItem){
              script.text += `,`;
            }
          });

          script.text += `]
              }
            }
          });
          `;
          $( "#googleTagManagerScript" ).before( script );*/

          this.cartResp = response.data;

          if(this.cartResp.bolt_batterns && this.cartResp.bolt_batterns.length>0){
            this.cartResp.bolt_batterns.sort((a, b) => {
              // Extracting the numerical part of the bolt strings
              const numA = parseFloat(a.split("x")[1]);
              const numB = parseFloat(b.split("x")[1]);
          
              // Comparing the numerical parts
              return numA - numB;
            });
          }
          const productcustomization = this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_customizations)];
          this.pc_cost_per_wheel = productcustomization.pc_cost_per_wheel ? productcustomization.pc_cost_per_wheel : '';

          const isCustomFinish = this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_customizations)].is_custom_finish;
          const isBoltPatterns = this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_customizations)].bolt_patterns;

          if(isCustomFinish && isBoltPatterns && isBoltPatterns.length){
              this.isProductCustomization = true;
          }else{
              this.isProductCustomization = false;
          }
          
          this.apiService.getAddsOnByProduct(this.cartItems[0].product_id).subscribe(
            response => {
              if(response.status){
                this.addons = response.data;
              }


            },
            error => {}
          );


          let element:HTMLElement = document.getElementById('auto_trigger') as HTMLElement;
          element.click();


          // if(this.addons != null ){
          //   let element:HTMLElement = document.getElementById('auto_trigger') as HTMLElement;
          //   element.click();
          // } else {
          //   this.router.navigateByUrl('/cart');
          // }

          this.toastr.success(response.message, 'Success');
        }
      }, error => {
        this.cartProcessing = false;
        this.toastr.error(error.error.message, 'Error');
      }
    );




  }

  getFirstKey(object:any){
    try {
      return (Object.keys(object)[0]);
    } catch{
      return '';
    }
  }


  goBack(){
    window.history.back();
  }

  showLightbox(index): void {
    this.selectedImageIndex = index;
    this.showFlag = true;
  }

  closeEventHandler(): void {
    this.showFlag = false;
    this.selectedImageIndex = -1;
  }

  onSubmitReviewForm(): void {
    if (this.reviewForm.valid)
    {
      this.apiService.addProductReview(this.reviewForm.value).subscribe(
        response => {
          if (response.status) {
            this.reviewForm.reset();
            this.productReviews.push(response.data);
            //this.successMessage = response.message;
            this.toastr.success(response.message, 'Success');
          }
        }, error => {
          this.helperService.showErrors(error);
        }
      );
    } else {
      this.reviewForm.markAllAsTouched();
    }
  }

  open(item: Finish): void {
    this.router.navigate(['/product/', item.id, item.model_id]);
  }

  addToWishlist(productId: any): void {
    if (!this.isLoggedIn) {
      this.toastr.error('Please login first');
    } else {
      this.isLoading = true;
      const formData = {
        product_variant_id: productId
      };
      this.apiService.addWishlist(formData).subscribe(response => {
        this.isLoading = false;
        this.toastr.success(response.message);
      }, error => {
        this.isLoading = false;
        this.helperService.showErrors(error);
      });
    }
  }


  openModal(content):void {
    this.addToCartPopup = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', centered: true,windowClass: 'wheel-modal'});

    this.addToCartPopup.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  closeModalAndRedirectCart = () => {
    this.modalService.dismissAll();
    this.router.navigateByUrl('/cart');
  }

  showPostPayPopup():void{
    this.showpostpaypopup = 'yes';
  }

  hidePostPayPopup():void{
    this.showpostpaypopup = 'no';
  }


  addTagManagerScript():void {
    let ProdName = this.wheelData.product_full_name;
    // $( "#gtagId" ).remove();
    let script = this._renderer2.createElement('script');
    script.id = 'gtagId';
    script.type = 'text/javascript';
    script.text = `
    dataLayer.push({
      'event': 'productClick',
      'ecommerce': {
        'click': {
          'products': [
            {
              'name': '`+ProdName+`',
              'id': '`+this.wheelData.id+`',
              'brand': '`+this.wheelData.brand.name+`',
              'model': '`+this.wheelData.model.name+`',
              'variant': '`+this.wheelData.variant.sku+`',
              'price': '`+this.wheelData.variant.uae_retail_price+`',
              'category': 'Alloy Wheel'
            }
          ]
        }
      }
    });

    dataLayer.push({
      'ecommerce': {
        'detail': {
          'products': [
            {
              'name': '`+ProdName+`',
              'id': '`+this.wheelData.id+`',
              'brand': '`+this.wheelData.brand.name+`',
              'model': '`+this.wheelData.model.name+`',
              'variant': '`+this.wheelData.variant.sku+`',
              'price': '`+this.wheelData.variant.uae_retail_price+`',
              'category': 'Alloy Wheel'
            }
          ]
        }
      }
    });
    `;
    $( "#googleTagManagerScript" ).before( script );


    // this._renderer2.appendChild(this._document.head, script);
  }

  generateOffsetDropdownValues(offset):void {
    this.offsetDropdownValues = [];
    // Parse offset value
    const parts = offset.split(/\/|to|-/);
    if (parts.length === 1) {
      // If only one value, assume it's a single offset
      this.offsetDropdownValues = [];
    } else if (parts.length === 2) {
      // If two values, assume it's a range
      const start = parseFloat(parts[0]);
      const end = parseFloat(parts[1]);
      if (!isNaN(start) && !isNaN(end)) {
        for (let i = start; i <= end; i++) {
          this.offsetDropdownValues.push(i);
        }
      }
    }
    this.offsetDropdownValues.sort((a, b) => a - b);
  }
  
  onCustomFinishSelect(event){
    const custom_finish = this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_customizations)].product_customizations.find(x => x.id == event.target.value);
    if(custom_finish){
      this.custom_finish_price = custom_finish.cost;
    }
  }
  addToCartFromProductCustomizationPopup(): void {
    this.p_customization_submitted = true;
    if(this.offsetDropdownValues.length == 0){
      this.offset = '';
    }
    if((this.cartResp?.product_customizations && this.cartResp?.product_customizations[this.getFirstKey(this.cartResp?.product_customizations)]?.bolt_patterns && (this.cartResp?.product_customizations && this.cartResp.product_customizations[this.getFirstKey(this.cartResp?.product_customizations)]?.bolt_patterns?.length == 0)) || (!!this.cartResp?.product_customizations &&  !this.cartResp?.product_customizations[this.getFirstKey(this.cartResp.product_customizations)]?.bolt_patterns)){
      this.bolt_pattern = '';
    }
    if((this.bolt_pattern == 'recommended' || this.offset == 'recommended') && !this.vehicle_year_make_model){
      return;
    }
    if((this.cartResp?.product_customizations && this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_customizations)]?.is_custom_finish && this.custom_finish) || (!this.cartResp?.product_customizations && !this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_customizations)]?.bolt_patterns && !this.custom_finish)){
      const session_id = localStorage.getItem('session_id');
      const product_id =this.wheelData.id;
      const product_variant_id = this.wheelData.variant.id;
      const data = {
        session_id,
        product_id,
        product_variant_id,
        type: "pc_updated_to_cart_directly",
        custom_finish: this.custom_finish,
        custom_finish_price: this.custom_finish_price,
        bolt_pattern: this.bolt_pattern,
        offset: this.offset,
        cost_per_wheel: this.pc_cost_per_wheel,
        vehicle_year_make_model : this.vehicle_year_make_model
      };
      this.cartProcessing = true;
      this.cartSubscription = this.apiService.addToCart(data).subscribe(
        response => {
            this.cartProcessing = false;
            if (response.status) {
              
              this.cartResp = response.data;
  
              this.apiService.getCart().subscribe(response => {
                if (response.status) {
                  this.dataService.setCartData(response);
                }
            });
  
            this.isProductCustomization = false;
            if (this.addToCartPopup) {
              this.addToCartPopup.close();
            }
            this.resetProdCustomizationProperties();
            let element:HTMLElement = document.getElementById('auto_trigger') as HTMLElement;
            element.click();
            this.toastr.success(response.message, 'Success');
          }
        }, error => {
          this.cartProcessing = false;
          this.toastr.error(error.error.message, 'Error');
        }
      );
    }
  }
  resetProdCustomizationProperties(){
    this.custom_finish = '';
    this.custom_finish_price = '';
    this.bolt_pattern = 'recommended';
    this.offset = 'recommended';
    this.pc_cost_per_wheel = '';
    this.vehicle_year_make_model = '';
    this.p_customization_submitted = false;
  }

  quantity: number = 4;
  minQuantity: number = 1;

  getTotalQtyProduct(inv){
    let totalQty = 0;
    inv.forEach( function(v,i) {
      totalQty += v.quantity;
    });

    return totalQty;
  }


   incrementQuantity(product_variant_id, in_stock_qty, eta_qty) {
  
    if(this.prodQty[product_variant_id] < (in_stock_qty+eta_qty)){
      this.prodQty[product_variant_id]++;
    }
    
  }

  decrementQuantity(product_variant_id, in_stock_qty, eta_qty) {
    if (this.prodQty[product_variant_id] > this.minQuantity) {
      this.prodQty[product_variant_id]--;
    }
  }

  
  getInventoryByProduct(product_id, product_variant_id){
    let inventory_loader = document.querySelector(".inventory_loader") as HTMLElement;
    let inventory_table = document.querySelector(".inventory_table") as HTMLElement;
    inventory_table.style.display = "none";
    inventory_loader.classList.remove("d-none");
    inventory_loader.classList.add("d-flex");

    this.inventoryData = [];
    this.apiService.getInventoryByProduct({product_id: product_id, variant_id: product_variant_id}).subscribe(
      response => {
        inventory_table.style.display = "block";
        inventory_loader.classList.remove("d-flex");
        inventory_loader.classList.add("d-none");

        this.inventoryData = response.data;
      }
    );
  }



}
